<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-md-12">
            <h3 class="mt-1">{{ catalogueItem.name }}</h3>

            <h5>
              <span
                    v-if="catalogueItem.on_promotion == 1"
                    class="badge badge-primary mr-2">On Promotion</span>


            </h5>


          </div>

        </div>

        <div class="row my-5">
          <div class="col-12">

            <div v-if="loading">
              <b-spinner
                         variant="primary"
                         style="width: 3rem; height: 3rem"
                         label="Large Spinner"></b-spinner>
            </div>


            <b-spinner
                       v-if="ImageLoading"
                       variant="primary"
                       style="width: 3rem; height: 3rem"
                       label="Large Spinner"></b-spinner>

            <v-lazy-image
                          @intersect="ImageLoading = true"
                          @load="ImageLoading = false"
                          v-if="selectedImage != null"
                          :src="selectedImage.large"
                          class="img-fluid border" />

            <p v-if="selectedImage != null" class="nl2br font-weight-bold bg-light p-1">
              {{ selectedImage.caption }}
            </p>

            <div
                 v-for="catalogueImage in catalogueItem.catalogue_item_images"
                 :key="catalogueImage.id"
                 class="inline float-left mr-1">

              <a
                 href="#"
                 @click="selectedImage = catalogueImage">
                <v-lazy-image
                              v-if="catalogueImage.small"
                              :src="catalogueImage.small"
                              style="height: 70px;"
                              class="img-fluid my-2 border" />
              </a>

            </div>


          </div>
        </div>

        <table class="table table-sm mt-2">
          <table-row
                     label="Description"
                     :noBorder="true"
                     v-if="catalogueItem.description">{{ catalogueItem.description }}</table-row>

          <table-row label="Group">{{ catalogueItem.product_group.name }}
          </table-row>

          <table-row label="Supplier">{{ catalogueItem.supplier.name }}
          </table-row>

          <table-row label="Brand">{{ catalogueItem.brand.name }}
          </table-row>

          <table-row
                     label="Cooking Instructions"
                     v-if="catalogueItem.cooking_instructions">{{ catalogueItem.cooking_instructions }}</table-row>

          <table-row label="Flavours">{{ catalogueItem.flavours }}
          </table-row>

          <table-row label="Portion Size">{{ catalogueItem.portion_size }}
          </table-row>

          <table-row label="Portions Per Pack">{{ catalogueItem.portions_per_pack }}
          </table-row>

          <table-row label="Case Size">{{ catalogueItem.case_size }}
          </table-row>

          <table-row label="Promote">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.on_promotion"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row
                     label="Promote Description"
                     v-if="catalogueItem.promotion_description">{{ catalogueItem.promotion_description
            }}</table-row>

          <table-row label="Pre Cooked">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.is_precooked"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row label="Deep Fry">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.can_deep_fry"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row label="Bake">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.can_bake"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row label="No Hormones">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.no_hormones"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row label="No Antibiotics">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.no_antibiotics"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row label="No Animal By-Products">
            <b-form-checkbox
                             style="margin-top: -7px"
                             :disabled="true"
                             v-model="catalogueItem.no_animal_by_products"
                             value="1"
                             unchecked-value="0"
                             switch />
          </table-row>

          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">{{ catalogueItem.id }} </table-row>

          <table-row label="Created">{{
            moment(new Date(catalogueItem.created_at)).format(
              "DD MMM YYYY, HH:mm:ss"
            )
          }}
          </table-row>
          <table-row label="Updated">{{
            moment(new Date(catalogueItem.updated_at)).format(
              "DD MMM YYYY, HH:mm:ss"
            )
          }}
          </table-row>
        </table>



      </b-col>
    </b-row>
  </div>
</template>

<script>
import catalogueRepo from "@/api/repos/catalogueRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getCatalogueItem();
  },

  data() {
    return {
      loading: false,
      catalogueItem: {
        product_group: {},
        supplier: {},
        brand: {},
      },
      newImage: { image_id: null, caption: null, is_default: 0 },
      submitStatus: null,
      errors: null,
      imageUploading: false,
      imageKey: 1,
      fileUploading: false,
      imagesTabActive: false,
      imageToEdit: {},
      ImageLoading: false,
      selectedImage: null
    };
  },

  methods: {
    async getCatalogueItem() {
      try {
        this.loading = true;
        let { data } = await catalogueRepo.get(this.id);
        this.catalogueItem = data.catalogueItem;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

};
</script>
